import {
    faImage, faLaptop, faTable, faFile, faSave, faEdit, faUsers, faTimes, faPhone, faTrash,
    faUser, faCalendar, faPlus, faSearch, faFilter, faList, faCheck, faCreditCard, faAddressCard,
    faMusic
}
    from '@fortawesome/free-solid-svg-icons';

export const IS_LOCALTEST = false;
export const HTML = 'html';
export const CLIPS = 'clips';
export const TAGS = 'tags';
export const LOGS = 'logs';
export const REPORTS = 'reports';
export const LAYOUT = 'layout';
export const AUTOSAVE = true;
export const OPEN = 'open';
export const CLOSED = 'closed';
export const EDIT = 'edit';
export const SAVE = 'save';
export const SEND = 'send';
export const RED = '#d5001c';
export const WHITE = 'white';
export const OWNER = 'owner';
export const ASC = 'asc';
export const DESC = 'desc';
export const SORTBY = 'sortby';
export const FULLTEXT = '_fulltext_';
export const DATETYPE = 'datetype';
export const LONGTYPE = 'longtype';
export const EDITORTYPE = 'editortype';
export const DROPDOWNTYPE = 'dropdowntype';
export const CHECKBOXTYPE = 'checkboxtype';
export const INFOTYPE = 'infoType';
export const HISTORYTYPE = 'historyType';
export const STATISTICTYPE = 'statisticType';
export const PREVIEWTYPE = 'previewType';
export const QUESTIONTYPE = 'questionType';
export const MAILINGTYPE = 'mailType';
export const IMAGETYPE = 'imageType';
export const INTLTYPE = 'intltype';
export const TEXTTYPE = 'texttype';
export const USERLIST = 'userlist';
export const LISTTYPE = 'listtype';
export const COUNTRYLIST = 'countrylist';
export const EDITOR = 'editor';
export const DATE = 'date';
export const BTN_BG = { backgroundColor: "transparent", boxShadow: "none" };
export const BORDER_RED = "1px solid red";
export const BORDER_LIGHT = "1px solid rgba(0,0,0,0.08)";
export const BORDER_NONE = 'none';
export const CLIPLISTTYPE = 'articles';
export const ARTICLES = 'articles';
export const ARTICLETYPE = 'article';
export const PUBlISHEDTYPE = 'articlepublished';
export const CHECK_MEDIATYPE = false;
export const ARTICLEVIEW = 'articleview';
export const ROLELIST = 'rolelist';
export const SEARCH = 'search';
export const BLOCK = 'block';
export const NONE = 'none';
export const THUMB_WIDTH = '370';
export const THUMB_HEIGHT = '200';
export const THUMB_WIDTH_XS = '130';
export const THUMB_HEIGHT_XS = '75';
export const HTLM_TITLE = 'Email from Flow';
export const APP_URL = '//vifogra.flowcenter.de';
export const ICON_RED = { color: RED };
export const ICON_WHITE = { color: WHITE };
export const SORTING = 'id|DESC';
export const SORTING_INTL = "page.cliplist.sorting.sorting";
export const IMAGE_URL = "https://vifogra.flowcenter.de/mfc/thumbnail.cgi?file=";
export const LOCALTEST_URL = 'http://localhost:5000/proxyapi/';
export const LOCALHOST = 'http://localhost:3000';
export const ACTION = "action";
export const USER = "user";
export const USERTYPE = "usertype";
export const CREATE = 'create';
export const CREATED = 'created';
export const PUBLISHED = 'published';
export const SAVE_SORTING = 'savesorting';
export const DOWNLOAD = 'download';
export const MAX_LOGS = 5;
export const SHOW_ALL = 'logsShowAll';
export const ADD_CLIP = 'addclip';
export const SHOW_MORE = 'showmore';
export const SHOW_LESS = 'showless';
export const SHOW_NONE = 'shownone';
export const ENTER = 'Enter';
export const ENTER_CODE = 13;
export const TODAY = 'today';
export const SEVENDAYS = 'sevendays';
export const THISMONTH = 'thismonth';
export const THISYEAR = 'thisyear';
export const FILTER_FORMAT = 'yyyyMMdd';
export const FILTER_MM = 'yyyyMM';
export const FILTER_YYYY = 'yyyy';
export const ALL = 'all';
export const ADD = 'add';
export const TCIN = 'tcin';
export const TCOUT = 'tcout';
export const DROPDOWN = 'dropdown';
export const LIST = 'list';
export const DATEBOX = 'datebox';
export const DATEGROUP = 'dategroup';
export const CHECKBOX = 'checkbox';
export const TEXT = 'text';
export const INPUT = 'input';
export const TEXTAREA = 'textarea';
export const MINUS = 'minus';
export const FPS = 25;
export const LATESTITEMS = 'latestitems';
export const LATESTMAX = 5;
export const INIT_DUR = 0.00001;
export const BTN_ACTIVE = 'custom-button custom-active';
export const ID = 'id';
export const UPLOAD = 'upload';
export const TERM = "<p><br></p>";
export const CANCEL = 'cancel';
export const SMALL = "small";
export const DELETE = 'delete';
export const ITEMS_PER_PAGE = 25;
export const LIMIT = 25;
export const REFRESH_TIME = 10000;
export const ACTIVE_BTN = {
    backgroundColor: '#d5001c',
    color: '#fff',
    border: '1px solid #d5001c'
}

export const TABLIST = [
    { name: DELETE, icon: faTrash, intl: "data.article.delete" },
    { name: LAYOUT, icon: faLaptop, intl: "data.article.layout" },
    { name: TAGS, icon: faTable, intl: "data.article.tags" },
    { name: CLIPS, icon: faImage, intl: "data.article.clips" },
    { name: LOGS, icon: faFile, intl: "data.article.logs" },
    { name: REPORTS, icon: faFile, intl: "data.article.downloads" },
    // { name: HTML, icon: faFile, intl: "data.article.html" },
];

export const BTN_STYLE = {
    backgroundColor: RED,
    color: "white",
    border: "1px solid #d5001c"
};

export const SEARCH_PARAMS = { keyword: "", customCurrentSortOption: "created|DESC" };
export const BTN_MEDIA = "custom-btn-rounded  custom-inactive";
export const LAYOUT_BTN_ITEMS = [
    // { name: EDIT, intl: "data.article.edit", icon: faEdit },
    { name: HTML, intl: "data.article.html", icon: faFile },
    // { name: SAVE, intl: "data.article.save", icon: faSave },
]

export const LOG_FIELDS = [
    { name: "date", intl: "data.article.log.date", icon: faCalendar, htmlclass: "col4", type: "datetype" },
    { name: "action", intl: "data.article.log.action", icon: faEdit, htmlclass: "col4" },
    { name: "user", intl: "data.article.log.user", icon: faUser, htmlclass: "col4" }
]

export const REPORT_FIELDS = [
    { name: "dldate", intl: "data.article.report.dldate", icon: faCalendar, htmlclass: "col2", type: "datetype" },
    { name: "userid", intl: "data.article.report.userid", icon: faUser, htmlclass: "col1", type: "usertype" },
    { name: "contactname", intl: "data.article.report.contactname", htmlclass: "col1" },
    { name: "contactphone", intl: "data.article.report.contactphone", htmlclass: "col1" },
    { name: "purpose", intl: "data.article.report.purpose", htmlclass: "col1" },
    { name: "clipid", intl: "data.article.report.clipid", icon: faList, htmlclass: "col1" },
    { name: "filename", intl: "data.article.report.filename", icon: faFile, htmlclass: "col1", showLargeTxt: true },
    { name: "paid", intl: "data.article.report.paid", icon: faCreditCard, htmlclass: "col1", type: "checkbox" },
    { name: "used", intl: "data.article.report.used", htmlclass: "col1", type: "checkbox" },
]

export const SHOW_BTN_ITEMS = [
    { name: SHOW_MORE, intl: "data.article.showmore" },
    { name: SHOW_LESS, intl: "data.article.showless" },
    { name: SHOW_NONE, intl: "data.article.shownone" }
]

export const FILTER_ITEMS = [
    { name: "data.article.filter.today", value: "today", intl: "data.article.filter.today" },
    { name: "data.article.filter.sevendays", value: "sevendays", intl: "data.article.filter.sevendays" },
    { name: "data.article.filter.thismonth", value: "thismonth", intl: "data.article.filter.thismonth" },
    { name: "data.article.filter.thisyear", value: "thisyear", intl: "data.article.filter.thisyear" }
]

export const MEDIASTATUS_ITEMS = [
    { name: "data.article.mediastatus.all", value: "all", intl: "data.article.mediastatus.all" },
    { name: "data.article.mediastatus.onlypublished", value: "onlypublished", intl: "data.article.mediastatus.onlypublished" },
    { name: "data.article.mediastatus.unpublished", value: "unpublished", intl: "data.article.mediastatus.unpublished" },
]

export const PUBLISHED_BTN_ITEMS = [
    { name: "cancel", intl: "data.article.cancel", icon: faTimes, htmlclass: "custom-btn", onClick: "closePopUp" },
    { name: "published", intl: "data.article.published", icon: faUsers, htmlclass: "custom-btn-active", onClick: "confirmPopUp" },
]

export const PUBLISHED_DD_ITEMS = [
    { name: "data.article.published.allcustomers", value: "all", ID: "all", intl: "data.article.published.allcustomers" },
    { name: "data.article.published.photocustomers", value: "foto", ID: "foto", intl: "data.article.published.photocustomers" },
    { name: "data.article.published.videocustomers", value: "video", ID: "video", intl: "data.article.published.videocustomers" },
    { name: "data.article.published.noemails", value: "none", ID: "none", intl: "data.article.published.noemails" },
]

export const PUBLISHED_CONTENT_ITEMS = [
    { name: "rename", intl: "data.article.published.rename", type: "checkbox", checked: true },
    { name: "iptc", intl: "data.article.published.iptc", type: "checkbox", checked: true },
    { name: "zip", intl: "data.article.published.zip", type: "checkbox", checked: true },
    { name: "ftp", intl: "data.article.published.ftp", type: "checkbox", checked: true },
    { name: "publish", intl: "data.article.published.publish", type: "checkbox", checked: true, invert: true },
    { name: "recipients", intl: "data.article.published.sendto", type: "dropdown", data: PUBLISHED_DD_ITEMS, required: true },
]

export const TC_TABS = [
    { name: "tab_chapters", value: "chapters", intl: "data.article.tc.tab_chapters", type: "btntab", isActive: true },
    { name: "tab_heroloop", value: "heroloop", intl: "data.article.tc.tab_heroloop", type: "btntab" },
    { name: "tab_transcripts", value: "transcripts", intl: "data.article.tc.tab_transcripts", type: "btntab" },
]
export const TC_FILTER_ITEMS = [
    { name: "data.article.filter.latestitems", value: "latestitems", intl: "data.article.filter.latestitems" },
    { name: "data.article.filter.today", value: "today", intl: "data.article.filter.today" },
    { name: "data.article.filter.sevendays", value: "sevendays", intl: "data.article.filter.sevendays" },
    { name: "data.article.filter.thismonth", value: "thismonth", intl: "data.article.filter.thismonth" },
    { name: "data.article.filter.thisyear", value: "thisyear", intl: "data.article.filter.thisyear" }
]

export const TC_BTN_ITEMS = [
    { name: ADD, icon: faPlus, intl: 'data.timecomment.add' },
    // { name: SEARCH, icon: faSearch, intl: 'data.timecomment.search' },
    // { name: 'commentsfilter', icon: faFilter, intl: 'data.timecomment.filter', type: 'dropdown', data: TC_FILTER_ITEMS },
    // { name: ALL, icon: faList, intl: 'data.timecomment.all' }
]

export const TC_EDIT_ITEMS = [
    { name: TCIN },
    // { name: MINUS },
    // { name: TCOUT }
]

export const CLIPS_ITEMS = [
    { clipListType: "articleview_mediatype", mediaType: "video", intl: "data.article.videos", icon: "faVideo", savedSorting: true },
    { clipListType: "articleview_mediatype", mediaType: "pictures", intl: "data.article.pictures", icon: "faImages", savedSorting: false, sortObj: "title|ASC" },
    //{ clipListType: "articleview_mediatype", mediaType: "audio", intl: "data.article.audios", icon: "faMusic", savedSorting: false, sortObj: "title|ASC" },
    { clipListType: "articleview_mediatype", mediaType: "other", intl: "data.article.other", icon: "faFile", savedSorting: false, sortObj: "title|ASC" }
]

export const CLIPS_ITEMS_ALL = [
    { clipListType: "articleview_mediatype", mediaType: "all", intl: "data.article.videos", icon: "faVideo", savedSorting: true, sortObj: "title|ASC" },
]

export const MEDIA_ITEMS = [
    // { name: "onlypublished", intl: "data.article.onlypublished", icon: "faUsers" },
    { name: "upload", intl: "data.article.upload", icon: "faArrowUp" }
]

export const POPUP_BTN_ITEMS = [
    { name: "cancel", intl: "data.cancel", icon: faTimes, htmlclass: "custom-btn-active", onClick: "closePopUp" },
    { name: "ok", intl: "data.ok", icon: faUsers, htmlclass: "custom-btn-active", onClick: "confirmPopUp" },
]

export const POPUP_INFO_ITEMS = [
    { name: "ok", intl: "data.ok", icon: faTimes, htmlclass: "custom-btn-active", onClick: "closePopUp" },
]
